import React, { createRef } from 'react';
import Modal from 'react-responsive-modal';
import styles from '../RateView.module.css';

import ButtonIconText from '../../button/ButtonIconText';
import PopupMenu from '../../popupmenu/PopupMenu';

import { getRequestProperties } from '../../../util/restapi';
import { getCurrentResource, findByKey } from '../../../util/tools';

import {
	TEMPLATE_MODE_SELECTED_ONLY,
	TEMPLATE_MODE_MARKED_ONLY,
	TEMPLATE_MODE_SELECTED_AND_MARKED,
} from '../../../util/consts/common';


class ButtonReport extends React.Component {
	
	rateView = null;
	/*
		holder, 
		formUrl, 
		mode, 
		style, 
		text, 
		tooltip, 
		icon
	*/
	constructor(props) {
		super(props);
		this.rateView = props.holder;
		this.refForm = createRef();
		this.refModal = createRef();
		this.resource = getCurrentResource().components.rateview.button.ButtonReport;
		
		this.state = { isModalOpen: false, mode: 'marked', query: null, markedIds: null, templateId: '' };
	}

	trySubmitForm = (templateId) => {
		this.setState({templateId: templateId})
		let template = findByKey( this.rateView.formInfo.listTemplate, 'templateId', templateId );
		if( template.mode == TEMPLATE_MODE_SELECTED_AND_MARKED ) {
			this.refModal.current.init();
			this.setState({isModalOpen: true})
		} else if( template.mode == TEMPLATE_MODE_SELECTED_ONLY ) {
			this.submitTemplateForm('selected');
		} else if( template.mode == TEMPLATE_MODE_MARKED_ONLY ) {
			this.submitTemplateForm('marked');
		}
	}
	closeModal = () => {
		this.setState({ isModalOpen: false });
		if( this.refModal.current.ok ) {
			let mode = this.refModal.current.mode; 
			this.submitTemplateForm(mode);
		}
	}
		
	submitTemplateForm = (mode) => {
		if( mode == 'marked' ) { 
			let rows = this.rateView.getSelectedRows();
			let selectedIds = '';
			let first = true;
			for( let row of rows) {
				if( first ) {
					first = false;
				} else {
					selectedIds += ',';
				}
				selectedIds += row.id;
			}
			this.setState(
				{mode: 'marked', markedIds: selectedIds, query: null}, 
				() => {this.refForm.current.submit()} );
		} else { // mode == 'selected'
			this.setState(
				{mode: 'selected', markedIds: '', query: this.rateView.query}, 
				() => {this.refForm.current.submit()} );
		}
	}
	
	
	render() {
		let res = this.resource;
		let listTemplate = this.rateView.formInfo.listTemplate;
		if( ! listTemplate )
			listTemplate = [];
		let requestProperties = getRequestProperties( this.props.formUrl );
	
		let objectsHtml = null;
		if( this.state.mode == 'marked' ) {
			objectsHtml = (
				<React.Fragment>
					<input type='hidden' name='objectsMode' value={'marked'} />
					<input type='hidden' name='objects' value={this.state.markedIds} />
					<input type='hidden' name='objectsQuery' value={''} />
				</React.Fragment>
			);
		} else {
			let jsonQuery = JSON.stringify(this.state.query);
			objectsHtml = (
				<React.Fragment>
					<input type='hidden' name='objectsMode' value={'selected'} />
					<input type='hidden' name='objects' value={''} />
					<input type='hidden' name='objectsQuery' value={jsonQuery} />
				</React.Fragment>
			);
		}
		if( listTemplate.length == 1) {
			let template = listTemplate[0];
			let templateId = template.templateId;
			return (
				<div style={this.props.style}>
					<form ref={this.refForm} action={requestProperties.url} method='post' target='_blank'>
						{objectsHtml}
						<input type='hidden' name='auth' value={requestProperties.authorization} />
						<input type='hidden' name='lang' value={requestProperties.language} />
						<input type='hidden' name='mode' value={this.props.mode} />
						<input type='hidden' name='template' value={this.state.templateId} />
					</form>
					<ButtonIconText 
						useIcon={this.rateView.useIcons} styles={styles}
						text={template.title} tooltip={template.description} icon={this.props.icon}
						onClick={ () => {this.trySubmitForm(templateId)} }
					/>
					<ReportOptionsModal ref={this.refModal}
						isModalOpen={this.state.isModalOpen} close={this.closeModal} 
					/>
				</div>		
			);
		} else { 
			let disabled = listTemplate.length == 0;
			let button = { text: this.props.text, tooltip: this.props.tooltip, icon: this.props.icon };
			let menu = { items: [] };
			for(let template of listTemplate) {
				menu.items.push( {
					title: template.title,
					tooltip: template.description,
					method: () => { this.trySubmitForm(template.templateId) }
				} )
			}
			return (
				<div style={this.props.style}>
					<form ref={this.refForm} action={requestProperties.url} method='post' target='_blank'>
						{objectsHtml}
						<input type='hidden' name='auth' value={requestProperties.authorization} />
						<input type='hidden' name='lang' value={requestProperties.language} />
						<input type='hidden' name='mode' value={this.props.mode} />
						<input type='hidden' name='template' value={this.state.templateId} />
					</form>
					<PopupMenu holder={this.rateView} button={button} menu={menu} disabled={disabled} />
					<ReportOptionsModal ref={this.refModal}
						isModalOpen={this.state.isModalOpen} close={this.closeModal} 
					/>
				</div>		
			);
		}
	}
}

class ReportOptionsModal extends React.Component {

	constructor(props) {
		super(props);
		this.resource = getCurrentResource().components.rateview.button.ButtonReport;
		this.mode = 'marked';
		this.ok = false;
		this.state = {dirtyCount: 0, };
	}
	init = () => {
		this.mode = 'marked';
		this.ok = false;
		this.setState({dirtyCount: 0});
	}
	
	submitForm = () => {
		this.ok = true;
		this.props.close();
	}

	handleInputEdit = (e) => {
		const {name, value} = e.target;
		if( name == 'mode' ) {
			this.mode = value;
		}
		this.setState({dirtyCount: this.state.dirtyCount+1})
	}
	
	render() {
		let res = this.resource;
		
		return (
			<Modal 
				open={this.props.isModalOpen} onClose={this.props.close} center 
				styles={styleModal}
				closeOnOverlayClick={false} animationDuration={1}
			>
				<div>
					<div style={{fontSize: '16pt', textAlign: 'center', padding: '10px', borderRadius: '21px 21px 0 0', backgroundColor: '#F0F0F0'}}>
						{res.modalTitle}
					</div>
					<div style={{marginTop: '10px', padding: '10px'}}>
						<div>
							<span style={{marginRight: '10px'}}>{res.labelMode}</span>
							<select name='mode' value={this.mode} onChange={this.handleInputEdit}>
								<option value='marked'>{res.optionMarked}</option>
								<option value='selected'>{res.optionSelected}</option>
							</select>
						</div>
						<div style={{marginTop: '7px', padding: '10px', marginRight: '15px', textAlign: 'right'}}>
							<button onClick={this.submitForm} title={res.buttonOkTooltip}>{res.buttonOk}</button>
						</div>
					</div>
				</div>
			</Modal>			
		)
	}
}

const styleModal = {
	modal: {
		background: '#ffffff',
		padding: '0px',
		borderRadius: '21px',
		maxWidth: '500px',
		width: '100%',
	},
	closeButton: {
		top: '10px',
		right: '10px',
		fill: '#FF0000',
		outline: 'none',
	},
};

export default ButtonReport;
